import $ from 'jquery';
import _ from 'underscore'; // eslint-disable-line import/no-extraneous-dependencies
import ModalView from 'eoxc/src/core/views/ModalView';
import OpenLayersMapView from 'eoxc/src/contrib/OpenLayers/OpenLayersMapView';
import RecordDetailsView from 'eoxc/src/search/views/RecordDetailsView';

import FiltersModel from 'eoxc/src/core/models/FiltersModel';
import HighlightModel from 'eoxc/src/core/models/HighlightModel';
import MapModel from 'eoxc/src/core/models/MapModel';
import LayersCollection from 'eoxc/src/core/models/LayersCollection';
import { isRecordDownloadable } from 'eoxc/src/download';
import LayerOptionsCoreView from 'eoxc/src/core/views/layers/LayerOptionsCoreView';

import IframeView from './IframeView';
import template from './RecordsDetailsModalView.hbs';
import './RecordsDetailsModalView.css';

const RecordsDetailsModalView = ModalView.extend({
  template,

  className: 'record-details-modal-view modal fade',

  templateHelpers() {
    return {
      title: '',
      hasNext: this.currentRecordIndex < this.records.length - 1,
      hasPrev: this.currentRecordIndex > 0,
      hasMore: this.records.length > 1,
    };
  },

  events: {
    'click .records-next': 'onRecordsNextClicked',
    'click .records-prev': 'onRecordsPrevClicked',
    'shown.bs.modal': 'onModalShown',
    'change .is-selected': 'onDownloadSelectionChange',
    'click .iframe-display-toggle': 'onIframeDisplayToggleChange',
    'click .whitebutton': 'onClose',
    'click .close': 'onClose',

  },

  regions: {
    content: '.modal-body',
    'layer-options': '.layer-options',
  },

  initialize(options) {
    this.records = options.records;
    this.currentRecordIndex = 0;
    this.iframeDisplayEnabled = null;

    this.baseLayersCollection = options.baseLayersCollection;
    this.overlayLayersCollection = options.overlayLayersCollection;
    this.layersCollection = options.layersCollection;
    this.highlightFillColor = options.highlightFillColor;
    this.highlightStrokeColor = options.highlightStrokeColor;

    this.filterFillColor = options.filterFillColor;
    this.filterStrokeColor = options.filterStrokeColor;
    this.filterOutsideColor = options.filterOutsideColor;
    this.projection = options.projection;

    this.mapModel = new MapModel({ center: [0, 0], zoom: 5, noclick: true, projection: this.projection });
    this.highlightModel = new HighlightModel();
    this.filtersModel = new FiltersModel();

    this.$el.sizeChanged(() => {
      this.updateResultsPanelSize();
    });
  },

  onModalShown() {
    this.updateRecord(...this.records[this.currentRecordIndex]);
    this.updateResultsPanelSize();
  },

  checkIframeDisplayEnabled(displayParams) {
    // UI management function for iframe toggle
    if (displayParams.enableIframeDisplay) {
      this.$('.iframe-checkbox-div').show();
      if (this.iframeDisplayEnabled === null) {
        this.iframeDisplayEnabled = displayParams.iframeVisible;
      }
      this.$('.iframe-display-toggle').prop('checked', this.iframeDisplayEnabled);
      const content = this.iframeDisplayEnabled ? "Client-side rendering" : "Server-side rendering";
      this.$('.iframe-checkbox-label').text(content);
    } else {
      this.$('.iframe-checkbox-div').hide();
      this.iframeDisplayEnabled = null;
    }
  },

  updateResultsPanelSize() {
    // resize results holding div based on variable footer and header sizes
    const restHeightCombined = $('.modal-header').outerHeight(true) + $('.modal-footer').outerHeight(true);
    $('.modal-body').height(`calc(100% - ${restHeightCombined}px)`);
  },

  updateRecord(recordModel, searchModel) {
    let time = recordModel.get('properties').time;
    if (time instanceof Date) {
      time = [time, time];
    }
    const layerModel = searchModel.get('layerModel');
    const displayParams = layerModel.get('detailsDisplay') || layerModel.get('display');
    this.mapModel.set('time', time);
    let mapView = null;
    this.checkIframeDisplayEnabled(displayParams);
    if (this.iframeDisplayEnabled) {
      mapView = new IframeView({
        recordModel,
        layerModel,
      });
    } else {
      mapView = new OpenLayersMapView({
        mapModel: this.mapModel,
        filtersModel: this.filtersModel,
        highlightModel: this.highlightModel,
        baseLayersCollection: this.baseLayersCollection,
        overlayLayersCollection: this.overlayLayersCollection,
        layersCollection: new LayersCollection([layerModel]),
        highlightFillColor: this.highlightFillColor,
        highlightStrokeColor: this.highlightStrokeColor,
        filterFillColor: this.filterFillColor,
        filterStrokeColor: this.filterStrokeColor,
        filterOutsideColor: this.filterOutsideColor,
        staticHighlight: true,
        useDetailsDisplay: true,
      });
    }

    const detailsView = new RecordDetailsView({
      model: recordModel,
      mapModel: this.mapModel,
      mapView: mapView,
      descriptionTemplate: layerModel.get('search.descriptionTemplate'),
      headerText: 'Description of',
      iframeView: this.iframeView,
    });
    this.showChildView('content', detailsView);

    this.filtersModel.set('area', recordModel.attributes.geometry);

    this.mapModel.show(recordModel.attributes);
    this.highlightModel.highlight(recordModel.attributes);

    this.$('.modal-title').text(`${layerModel.get('displayName')} - ${time[0].toISOString()}`);
    this.$('.records-prev').toggleClass('disabled', !(this.currentRecordIndex > 0));
    this.$('.records-next').toggleClass('disabled', !(this.currentRecordIndex < this.records.length - 1));
    this.$('.current-record').text(this.currentRecordIndex + 1);
    this.$('.record-count').text(this.records.length);

    const downloadSelection = searchModel.get('downloadSelection');
    const isSelectedForDownload = downloadSelection.findIndex(model => (
      model.get('id') === recordModel.get('id')
    )) !== -1;
    this.$('.is-selected').prop('checked', isSelectedForDownload);
    this.$('.is-selected').parent().toggle(!!isRecordDownloadable(layerModel, recordModel));

    this.$('.layer-options-dropdown').toggle(!!displayParams.options);
    this.showChildView('layer-options', new LayerOptionsCoreView({
      model: layerModel,
      useDetailsDisplay: true,
      recordModel,
    }));
  },

  onRecordsPrevClicked() {
    if (this.currentRecordIndex > 0) {
      this.currentRecordIndex -= 1;
      this.updateRecord(...this.records[this.currentRecordIndex]);
    }
  },

  onRecordsNextClicked() {
    if (this.currentRecordIndex < this.records.length - 1) {
      this.currentRecordIndex += 1;
      this.updateRecord(...this.records[this.currentRecordIndex]);
    }
  },

  onDownloadSelectionChange() {
    const [recordModel, searchModel] = this.records[this.currentRecordIndex];
    const downloadSelection = searchModel.get('downloadSelection');
    if (this.$('.is-selected').is(':checked')) {
      downloadSelection.add(recordModel);
    } else {
      downloadSelection.remove(recordModel);
    }
  },

  onIframeDisplayToggleChange() {
    this.iframeDisplayEnabled = this.$('.iframe-display-toggle').is(':checked');
    this.updateRecord(...this.records[this.currentRecordIndex]);
  },

  replaceLayerParameters(option, layerModel, recordModel) {
    // perform replacing of parameters in underyling model if it was configured
    const replaceList = option.replace;
    _.each(replaceList, (config) => {
      if (typeof config.target === 'string' && typeof config.value !== 'undefined') {
        if (config.value.template) {
          let evaluated = null;
          // interpolate template from Record if able
          if (recordModel) {
            // special prefix record.something for interpolation
            evaluated = _.template(config.value.template, {
              interpolate: /\{\{record\.(.+?)\}\}/g
            })(recordModel.toJSON());
          }
          // fallback, interpolate template from layer if able
          if (typeof evaluated === 'string' && evaluated.includes('{{')) {
            evaluated = _.template(config.value.template, {
              interpolate: /\{\{(.+?)\}\}/g
            })(layerModel.toJSON());
          }
          layerModel.set(config.target, evaluated);
        } else {
          layerModel.set(config.target, config.value);
        }
      }
    });
    if (typeof option.IdAttached !== 'undefined') {
      // default layerID when adding attachment is layer.id itself
      let displayOption = layerModel.get('detailsDisplay') ? 'detailsDisplay' : 'display';
      let layerID = layerModel.get(`${displayOption}.id`);
      if (layerModel.get(`${displayOption}.extraParameters.LAYERS`)) {
        // if extraParameters.LAYERS override was already set during replace
        // only append attachment to it
        layerID = layerModel.get(`${displayOption}.extraParameters.LAYERS`);
      }
      layerID = layerID + option.IdAttached;
      layerModel.set(`${displayOption}.extraParameters.LAYERS`, layerID);
    }
  },

  applySettings(layerModel, recordModel) {
    let displayOption = layerModel.get('detailsDisplay') ?  'detailsDisplay' : 'display';
    layerModel.set(`${displayOption}.variablesParameter`, '');
    // set values from currently chosen form/s in layerModel
    const options = layerModel.get(`${displayOption}.options`);
    // first reset the unselected options to clear the parameters
    _.each(options, (option) => {
      _.each(option.parameters, (param) => {
        if (option.isChosen !== true) {
          layerModel.set(param.target, '');
        }
      });
    });

    // to set the parameter values for the chosen option
    _.each(options, (option, i) => {
      _.each(option.parameters, (param, j) => {
        const $forms = this.$(`#visualization-selector_${i}`).parent().parent().find(`[data-counter='${j}']`);
        const values = [];
        const selectedIndices = [];
        _.each($forms, (form) => {
          // either get value from range input or from select input
          let value = form.value;
          const separatorToReplace = param.rangeSeparator;
          if (separatorToReplace) {
            value = value.replace(",", separatorToReplace)
          }
          values.push(value);
          if (typeof param.min === 'undefined') {
            selectedIndices.push(form.selectedIndex);
          }
        });

        // reset isSelected in layerModel and update it with what is selected in ui
        _.each(param.values, (_, l) => {
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${l}].isCurrentB1`, false);
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${l}].isCurrentB2`, false);
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${l}].isCurrentB3`, false);
        });

        if (typeof param.min === 'undefined') {
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${selectedIndices[0]}].isCurrentB1`, true);
        }
        if (param.selectThree && typeof param.min === 'undefined') {
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${selectedIndices[1]}].isCurrentB2`, true);
          layerModel.set(`${displayOption}.options[${i}].parameters[${j}].values[${selectedIndices[2]}].isCurrentB3`, true);
        }

        if (option.isChosen === true) {
          // set options to layerModel and trigger a reload of layer in map
          if(param.oneToManyMapping){
            let variables = layerModel.get(param.target) || {};
            variables[param.value] =  values.join(',')
            let variablesParameter = []
            _.each(_.keys(variables), key => {
              variablesParameter.push(`${key}=${variables[key]}`)
            });
            layerModel.set(`${displayOption}.variablesParameter`, variablesParameter.join(','));
            layerModel.set(param.target, variables);
          }
          else{
            layerModel.set(param.target, values.join(','));
          }
        }
      })
    });
    _.each(layerModel.get(`${displayOption}.options`), (option) => {
      if (option.isChosen === true) {
        // if replace was configured for this option, apply it
        this.replaceLayerParameters(option, layerModel, recordModel);
      }
    });
  },
  onClose(){
    const [recordModel, searchModel] = this.records[this.currentRecordIndex];
    const layerModel = searchModel.get('layerModel');
    let displayOption = layerModel.get('detailsDisplay') ?  'detailsDisplay' : 'display';
    const originalID = layerModel.get(`${displayOption}.id`);
    layerModel.set(`${displayOption}.extraParameters.LAYERS`, originalID);
    layerModel.set(`${displayOption}.extraParameters.VARIABLES`, '');
    _.each(layerModel.get(`${displayOption}.options`), (option, i) => option.isChosen = i === 0 ? true : false);
    this.applySettings(layerModel, recordModel)
  }
});

export default RecordsDetailsModalView;



// WEBPACK FOOTER //
// /src/views/RecordsDetailsModalView.js